import React, { useContext } from "react";
import styled, { css } from "styled-components";

import IconButton, { IconButtonThemes } from "../../../components/Button/IconButton";
import { PlusIcon } from "../../../components/Icons/Icons";
import { TextTypes } from "../../../types/scene";
import { VideoEditorContext } from "../../../App";

const textOptions = [
  { label: "Add title", value: "Title", textType: TextTypes.title, variant: "title" as const },
  { label: "Add subtitle", value: "Subtitle", textType: TextTypes.subtitle, variant: "subtitle" as const },
  { label: "Add body text", value: "Body", textType: TextTypes.bodyText, variant: "bodyText" as const },
];

const AddTextPanel = () => {
  const { handleAddText } = useContext(VideoEditorContext);

  return (
    <AddTextsWrapper>
      {textOptions.map(({ label, value, textType, variant }, index) => (
        <Row
          key={index}
          onClick={(e: React.MouseEvent<HTMLElement>) => {
            e.stopPropagation();
            handleAddText(value, textType);
          }}
        >
          <TextStyle variant={variant}>{label}</TextStyle>
          {/* <PlusButtonWrapper>
            <IconButton icon={<PlusIcon />} iconButtonTheme={IconButtonThemes.Rounded} />
          </PlusButtonWrapper> */}
        </Row>
      ))}
    </AddTextsWrapper>
  );
};

const AddTextsWrapper = styled.div`
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
`;

const Row = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.primaryBackground1};
  border: 1px solid #343539;
  height: 46px;
`;

const TextStyle = styled.p<{ variant: "title" | "subtitle" | "bodyText" }>`
  cursor: pointer;
  margin: 0;
  color: ${({ theme }) => theme.white};
  ${(props) =>
    props.variant === "title" &&
    css`
      font-weight: 600;
      font-size: 24px;
      line-height: 32px;
    `}
  ${(props) =>
    props.variant === "subtitle" &&
    css`
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    `}
    ${(props) =>
    props.variant === "bodyText" &&
    css`
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
    `};
`;

export default AddTextPanel;
